import type { ComponentPropsWithoutRef } from 'react'
import cn from 'clsx'

import styles from './VisuallyHidden.module.css'

export type TVisuallyHiddenProps = ComponentPropsWithoutRef<'span'>

/** Text that only assistive technology reads — an accessible name for an icon-only control. */
export const VisuallyHidden = ({ className, ...props }: TVisuallyHiddenProps) => (
    <span className={cn(styles.visuallyHidden, className)} {...props} />
)
